// extracted by mini-css-extract-plugin
module.exports = {"image":"jgp-2a-kC","name":"jgp-zMHEM","logoWrapper":"jgp-2UDCu","logoImage":"jgp-91OSO"};